import React from 'react';

const AuthContext = () => {
  return (
    <>
      <p>
        Go to your list of past appointments to file a travel reimbursement
        claim for eligible appointments.
      </p>
      <va-link-action
        data-testid="vagov-smoc-link"
        href="/my-health/appointments/past"
        text="Go to your past appointments"
      />
      <p>
        Or you can check the status of all your travel reimbursement claims.
      </p>
      <va-link-action
        data-testid="vagov-travel-pay-link"
        type="secondary"
        href="/my-health/travel-pay/claims"
        text="Review your travel reimbursement claims"
      />
      <p>
        <strong>Note:</strong> You’ll need to use the Beneficiary Travel Self
        Service System (BTSSS) if your travel was one way or if it started from
        an address other than the one we have on file.
      </p>
      <va-link
        data-testid="btsss-link"
        href="https://dvagov-btsss.dynamics365portals.us/signin"
        text="Go to BTSSS website"
        label="Go to the Beneficiary Travel Self-Service System (BTSSS)"
      />
    </>
  );
};

export default AuthContext;
